import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=4fbe5a95&"
import script from "./StepItem.vue?vue&type=script&lang=js&"
export * from "./StepItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports